export default __webpack_public_path__ + "static/media/dep.2db41e87.png";